<template>

<header class="flex justify-between items-center p-2 px-6">
      <div class="text-3xl font-bold text-blue-900">
        <router-link class="" to="/">Naturel&Joli</router-link> 
      </div>
      <nav class="hidden md:flex space-x-8 text-blue-900">
  <router-link class="hover:underline" to="/">Accueil</router-link>
  <router-link class="hover:underline" to="/categorie">Nos Services</router-link>
  <router-link class="hover:underline" to="/rendez-vous">Prendre Rendez-vous</router-link>
</nav>

<div class="flex items-center space-x-4 relative">
  <template v-if="isLogin">
    <div @click="dropdownOpen = !dropdownOpen" class="cursor-pointer flex items-center space-x-2 text-white bg-[#cd825b] px-4 py-2 rounded-lg">
      <span>{{ user.nom }}</span>
      <i class="fas fa-chevron-down"></i>
    </div>
    <div class="relative" @click="dropdownOpen = !dropdownOpen">

  <!-- Submenu -->
  <div
    v-if="dropdownOpen"
    class="absolute right-0 mt-2 w-48 bg-white border rounded shadow-md z-50"
  >
    <router-link to="/booking" class="block px-4 py-2 hover:bg-gray-100 text-blue-900">Mes rendez-vous</router-link>
    <button @click="logout" class="w-full text-left px-4 py-2 hover:bg-gray-100 text-blue-900">Se déconnecter</button>
  </div>
</div>

  </template>

  <template v-else>
    <router-link to="/signup">
      <button class="px-4 py-2 bg-blue-900 rounded-lg text-white">Mon Compte</button>
    </router-link>
  </template>

  <button @click="toggleMenu" class="md:hidden menu-toggle" :class="{ open: isMenuOpen }">
    <i class="fas fa-bars text-blue-900"></i>
  </button>
</div>

    </header>

    <div
  class="mobile-menu md:hidden overflow-hidden transition-all duration-300"
  :class="isMenuOpen ? 'max-h-screen' : 'max-h-0'"
>
  <nav class="flex flex-col space-y-4 p-4 text-blue-900">
    <router-link class="hover:underline" to="/">Accueil</router-link>
    <router-link class="hover:underline" to="/categorie">Nos Services</router-link>
    <router-link class="hover:underline" to="/rendez-vous">Prendre Rendez-vous</router-link>
    <router-link class="hover:underline" to="/signup">Mon Compte</router-link>
  </nav>
</div>


  <router-view/>
  <ReviewComponents />
<!-- Top image gallery with center Instagram circle -->
<div class="flex flex-wrap justify-center relative">
  <img alt="Black and white portrait of a woman with hair covering half of her face" class="w-1/3 sm:w-1/6 min-w-[100px] object-cover" height="300" src="https://storage.googleapis.com/a1aa/image/4ff06e7e-eec0-4759-2b83-760b69a4b859.jpg" width="200"/>
  <img alt="Amber bottle with white label and matching box on white background" class="w-1/3 sm:w-1/6 min-w-[100px] object-cover" height="300" src="https://storage.googleapis.com/a1aa/image/94c99735-2712-4645-e8c6-32d166b05230.jpg" width="200"/>
  <img alt="Smiling woman holding a facial pad over one eye on beige background" class="w-1/3 sm:w-1/6 min-w-[100px] object-cover" height="300" src="https://storage.googleapis.com/a1aa/image/027c4592-72bc-4536-66ad-279a5fcf9579.jpg" width="200"/>
  <img alt="Black and white portrait of a woman with hair covering half of her face" class="w-1/3 sm:w-1/6 min-w-[100px] object-cover" height="300" src="https://storage.googleapis.com/a1aa/image/4ff06e7e-eec0-4759-2b83-760b69a4b859.jpg" width="200"/>
  <img alt="Amber bottle with white label and matching box on white background" class="w-1/3 sm:w-1/6 min-w-[100px] object-cover" height="300" src="https://storage.googleapis.com/a1aa/image/94c99735-2712-4645-e8c6-32d166b05230.jpg" width="200"/>
  <img alt="Smiling woman holding a facial pad over one eye on beige background" class="w-1/3 sm:w-1/6 min-w-[100px] object-cover" height="300" src="https://storage.googleapis.com/a1aa/image/027c4592-72bc-4536-66ad-279a5fcf9579.jpg" width="200"/>
  <!-- Logo Instagram centré dans div -->
  <div class="absolute bg-white rounded-full w-20 h-20 flex justify-center items-center cursor-pointer top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
    <i class="fab fa-instagram text-[#a02a0f] text-xl"></i>
  </div>
</div>



<!-- Footer main section -->
<footer class="bg-[#0a0d26] text-white py-16 px-6 md:px-20">
  <div class="grid grid-cols-1 md:grid-cols-4 gap-10">
    
    <!-- Logo -->
    <div>
      <h1 class="text-4xl font-playfair font-semibold">
        Naturel & Joli
      </h1>
    </div>

    <!-- Contact -->
    <div>
      <h2 class="font-playfair text-lg mb-4 " >Contactez-Nous</h2>
      <p class="text-gray-300 mb-2">Téléphone : 07 61 16 93 08</p>
      <p class="text-gray-300 mb-2">
        Instagram :
        <a href="https://www.instagram.com/Natureletjoli" target="_blank" class="text-indigo-300 hover:underline">
          @Natureletjoli
        </a>
      </p>
      <p class="text-gray-300 mb-2">257 Rue de Paris, 95150 Taverny</p>
    </div>

    <!-- Horaires -->
    <div>
      <h2 class="font-playfair text-lg mb-4">Horaires</h2>
      <p class="text-gray-300 mb-2">Lundi - Samedi : 9h - 20h</p>
      <p class="text-gray-300 mb-2">Dimanche : Fermé</p>
    </div>

    <!-- Navigation -->
    <div>
      <h2 class="font-playfair text-lg mb-4">Navigation</h2>
      <nav class="flex flex-col space-y-2 text-gray-300">
        <a class="hover:underline text-white" href="#">Nos Services</a>
        <a class="hover:underline text-white" href="#">Prendre Rendez-vous</a>
        <a class="hover:underline text-white" href="#">Mon Compte</a>
      </nav>
    </div>
  </div>

</footer>


  <!-- Bottom bar without chat and right buttons -->
  <div class="bg-[#0a0d26] border-t border-gray-800 flex items-center justify-center md:justify-center px-6 md:px-20 py-4 text-gray-400 text-sm">
    <p class="text-sm text-gray-400">
      Réalisé par <span class="text-white font-semibold">DATAFUSE</span> – Tous droits réservés © <span class="text-white">Naturel & Joli</span>
    </p>
  </div>

  <!-- Bottom right up arrow -->
  <button aria-label="Remonter en haut" class="fixed bottom-6 right-6 w-14 h-14 bg-[#0a1a4f] rounded-full text-white flex items-center justify-center cursor-pointer">
   <i class="fas fa-arrow-up">
   </i>
  </button>
</template>
<script>
import ReviewComponents from './components/ReviewComponents.vue';

export default {
  components: { ReviewComponents },
  data() {
    return {
      email: '',
      isMenuOpen: false,
      isLogin: false,
      dropdownOpen: false,
      user: {
        nom: '',
        prenom: '',
        id: '',
      },
    };
  },
  mounted() {
    const token = localStorage.getItem('clientToken');
    if (token) {
      fetch('http://localhost:3000/api/clients/verify-token', {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.message === 'Token valide') {
            this.isLogin = true;
            this.user = {
              nom: data.user.nom,
              prenom: data.user.prenom,
              id: data.user.id,
            };
            localStorage.setItem( 'USERID' , data.user.id);
            console.log('Utilisateur connecté :', this.user);
          } else {
            console.warn('Token invalide, déconnexion.');
            this.logout();
          }
        })
        .catch((err) => {
          console.error('Erreur lors de la vérification du token :', err);
          this.logout();
        });
    }
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    logout() {
      localStorage.removeItem('clientToken');
      this.isLogin = false;
      this.dropdownOpen = false;
      this.user = { nom: '', prenom: '', id: '' };
      alert('Déconnecté avec succès');
    },
  },
};
</script>


<style>
#app {
  font-family: 'Playfair Display', serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: rgb(205, 130, 91);
}

h1 {
  font-family: 'Playfair Display', serif;
}

nav {
  padding: 30px;
  cursor: pointer;
}

nav a {

  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: rgb(205, 130, 91);
}

body {
  font-family: 'Roboto', sans-serif;
}
</style>
